export const load = () => ({
	h1: 'Case Studies: Indow Inserts in Action ',
	title: 'Window Insert Case Studies and Examples',
	description:
		"Our window insert case studies show our inserts in action. Learn how Indow understood the challenges a customer faced and how Indow was the customer's ally making their space more comfortable.",
	showTitle: true,
});
